import { lazy } from "react";
import EditProfile from "../pages/Settings/EditProfile";
import StarredMessages from "../pages/Settings/StarredMessages";

const ContactsPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Contacts"));
const CampaignPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Campaign"));
const DashboardPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Dashboard"));
const MessagesPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Messages"));
const GroupsPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Groups"));
const ErrorPage = lazy(() => import(/* webpackChunkName: "ErrorPage" */ "../pages/ErrorPage"));
const SettingsPage = lazy(() => import(/* webpackChunkName: "ErrorPage" */ "../pages/Settings"));
const ForgetPassword = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/ForgotPassword"));
const ReportPage = lazy(() => import(/* webpackChunkName: "Home" */ "../pages/Reports"));
const NewEditCampaign = lazy(
  () => import(/* webpackChunkName: "Home" */ "../pages/Campaign/NewEditCampaign"),
);
const ViewAdvAndCampaign = lazy(
  () => import(/* webpackChunkName: "Home" */ "../components/shared/ViewAdvAndCampaign"),
);

const TransactionPage = lazy(
  () => import(/* webpackChunkName: "Home" */ "../pages/Checkout/transaction"),
);
const ArchivedConversations = lazy(
  () =>
    import(
      /* webpackChunkName: "ArchivedConversations" */ "../pages/Settings/ArchivedConversations"
    ),
);
const ChangePassword = lazy(
  () => import(/* webpackChunkName: "ChangePassword" */ "../pages/Settings/ChangePassword"),
);
const BlockedContacts = lazy(
  () => import(/* webpackChunkName: "BlockedContacts" */ "../pages/Settings/BlockedContacts"),
);
const Privacy = lazy(() => import(/* webpackChunkName: "Privacy" */ "../pages/Settings/Privacy"));
const ContactUs = lazy(
  () => import(/* webpackChunkName: "ContactUs" */ "../pages/Settings/ContactUs"),
);
const ForgotPassword = lazy(
  () => import(/* webpackChunkName: "ForgotPassword" */ "../pages/ForgotPassword"),
);
const ExploreSubscription = lazy(
  () =>
    import(
      /* webpackChunkName: "ExploreSubscription" */ "../pages/Settings/Account/ExploreSubscription"
    ),
);
const PaymentHistory = lazy(
  () => import(/* webpackChunkName: "PaymentHistory" */ "../pages/Settings/Account/PaymentHistory"),
);
const Account = lazy(() => import(/* webpackChunkName: "Account" */ "../pages/Settings/Account"));
const Authenticator2FA = lazy(
  () => import(/* webpackChunkName: "Authenticator2FA" */ "../pages/Settings/Authenticator2FA"),
);
const AutoReplies = lazy(
  () => import(/* webpackChunkName: "AutoReplies" */ "../pages/Settings/AutoReplies"),
);

const settingsSubRoutes = [
  {
    path: "edit-profile",
    component: <EditProfile />,
  },
  {
    path: "starred-messages",
    component: <StarredMessages />,
  },
  {
    path: "archived-conversations",
    component: <ArchivedConversations />,
  },
  {
    path: "change-password",
    component: <ChangePassword />,
  },
  {
    path: "blocked-contacts",
    component: <BlockedContacts />,
  },
  {
    path: "privacy-and-security",
    component: <Privacy />,
  },
  { path: "account", component: <Account /> },
  { path: "auto-replies", component: <AutoReplies /> },

  { path: "payment-history", component: <PaymentHistory /> },

  { path: "explore-subscription", component: <ExploreSubscription /> },

  { path: "authenticator-2FA", component: <Authenticator2FA /> },

  { path: "forgot-password-auth", component: <ForgotPassword /> },
  { path: "contact-us", component: <ContactUs /> },
];

const mainRoutes = [
  {
    path: "/dashboard",
    id: "dashboardPage",
    component: <DashboardPage />,
  },
  {
    path: "/messages",
    id: "messagesPage",
    component: <MessagesPage />,
  },
  {
    path: "/contacts",
    component: <ContactsPage />,
  },
  {
    path: "/campaign",
    component: <CampaignPage />,
  },
  {
    path: "/new/campaign",
    component: <NewEditCampaign />,
  },
  {
    path: "/groups",
    component: <GroupsPage />,
  },
  {
    path: "/settings",
    component: <SettingsPage />,
    children: settingsSubRoutes,
  },
  {
    path: "/reports",
    component: <ReportPage />,
  },
];

const lastRoutes = [
  {
    path: "/forgot-password-auth",
    component: <ForgetPassword />,
  },
  {
    path: "/reports/:id",
    component: <ReportPage />,
  },
  {
    path: "/campaign/view/:id",
    component: <ViewAdvAndCampaign />,
  },
  {
    path: "/campaign/:type/:id",
    // component: <CampaignPage />,
    component: <NewEditCampaign />,
  },
  {
    path: "/checkout/:id",
    component: <TransactionPage />,
  },
  // Error Page
  {
    path: "/error",
    component: <ErrorPage />,
  },
  // Auth
  {
    path: "/",
    component: null,
    redirect: true,
    to: "/dashboard",
  },
  {
    path: "/register",
    component: null,
    redirect: true,
    to: "/dashboard",
  },
  // redirect to 404 page
  {
    path: "/*",
    id: "error",
    component: null,
    redirect: true,
    to: "/error",
  },
];

export { mainRoutes, lastRoutes };
